export class MDDomicileBodyModel {
    constructor(
        public isDocReadable: string,
        public hasBarcode: string,
        public afterPeriod: string,
        public barcode: string,
        public reEnterBarcode: string,
    ) { }
}